'use client'

import appConfig from '#/src/appConfig'
import { createAppConfigContext } from 'app-config-utils/client-side/createAppConfigContext'
import type { ComponentProps } from 'react'

const [Provider] = createAppConfigContext(appConfig)

/**
 * Wrapper around the context provider created by `createAppConfigContext`.
 *
 * This extra component is necessary because JSX and React (especially with Next.js)
 * require component types to be statically analyzable. Directly exporting a component
 * from array destructuring (e.g., `export const [AppConfigContextProvider] = ...`)
 * does not work with React's rendering pipeline and causes runtime errors.
 *
 * Always wrap the provider like this before using it in JSX.
 */
export const AppConfigContextProvider = ({ value, children }: ComponentProps<typeof Provider>) => {
  return <Provider value={value}>{children}</Provider>
}
